import { useQuery } from "@tanstack/react-query";
import { getAppConfig } from "./api";

const buildTimeTurnstileSiteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY?.trim() ?? "";

export type TurnstileConfig = {
  siteKey: string;
  required: boolean;
  isLoading: boolean;
  isMisconfigured: boolean;
};

export const useTurnstileConfig = (): TurnstileConfig => {
  const configQuery = useQuery({
    queryKey: ["app-config"],
    queryFn: getAppConfig,
    staleTime: Infinity,
    enabled: !buildTimeTurnstileSiteKey,
  });

  const siteKey = buildTimeTurnstileSiteKey || configQuery.data?.turnstileSiteKey?.trim() || "";
  const required = buildTimeTurnstileSiteKey ? true : (configQuery.data?.turnstileRequired ?? false);
  const isLoading = !buildTimeTurnstileSiteKey && configQuery.isLoading;

  return {
    siteKey,
    required,
    isLoading,
    isMisconfigured: required && !siteKey && !isLoading,
  };
};

export const useTurnstileSiteKey = () => useTurnstileConfig().siteKey;
